import ApiNode from "./ApiNode";

export default {
  // Get monthly growth dashboard data
  getMonthlyGrowthData(params = {}) {
    return ApiNode().get("growth-dashboard", { params });
  },

  // Get client-wise growth dashboard data
  getClientWiseGrowthData(params = {}) {
    return ApiNode().get("growth-dashboard/client-wise", { params });
  },

  // Get shipping line-wise growth dashboard data
  getShippingLineWiseGrowthData(params = {}) {
    return ApiNode().get("growth-dashboard/shipping-line-wise", { params });
  },

  // Get branch-wise growth dashboard data
  getBranchWiseGrowthData(params = {}) {
    return ApiNode().get("growth-dashboard/branch-wise", { params });
  },

  getBranchWiseGrowthDataMonthly(params = {}) {
    return ApiNode().get("growth-dashboard/branch-wise-month", { params });
  },

  // Get assignment job details with profit loss
  getAssignmentJobDetails(params = {}) {
    return ApiNode().get("growth-dashboard/assignments", { params });
  },

  // Export growth dashboard data to Excel
  exportGrowthDashboardData(params = {}) {
    return ApiNode().get("growth-dashboard/export", {
      params,
      responseType: 'blob'
    });
  },

  // Get growth dashboard data for specific year
  getGrowthDashboardByYear(year, params = {}) {
    return ApiNode().get(`growth-dashboard/year/${year}`, { params });
  },

  // Get comprehensive dashboard data (if needed in future)
  getComprehensiveDashboardData(params = {}) {
    return ApiNode().get("growth-dashboard/comprehensive", { params });
  }
};



// WEBPACK FOOTER //
// ./src/services/GrowthDashboardService.js